import React from "react";

import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  EnvelopeIcon,
  MapMarkerAltIcon,
  PhoneAltIcon
} from "@patternfly/react-icons";


const ContactPage = () => {
  return (
    <>
      <PageSection isWidthLimited>
        <Stack hasGutter>
            <StackItem>
            <Grid>
                <GridItem span={12} md={8} mdOffset={2}>
                <Content style={{ textAlign: "center" }}>
                    <h1>Kontakt</h1>
                    <p>
                    Podstawowe informacje o naszej placówce.
                    </p>
                </Content>
                </GridItem>
            </Grid>
            </StackItem>

            <StackItem>
            <Grid>
                <GridItem
                span={12}
                md={10}
                mdOffset={1}
                lg={8}
                lgOffset={2}
                >
                <Grid hasGutter>
                    <GridItem span={12} md={6}>
                        <Card isFullHeight isGlass>
                            <CardBody>
                                <Stack hasGutter>
                                {/* <StackItem>
                                    <Content>
                                    <h2>Centrum Kształcenia Zawodowego i Ustawicznego w Wyrzysku</h2>
                                    </Content>
                                </StackItem> */}

                                <StackItem>
                                    <Grid hasGutter>
                                    <GridItem span={12}>
                                        <div
                                        style={{
                                            display: "flex",
                                            gap: "1rem",
                                            alignItems: "flex-start"
                                        }}
                                        >
                                        <MapMarkerAltIcon />

                                        <Content>
                                            <strong>Adres</strong>

                                            <p>
                                            ul. Wiejska 1
                                            <br />
                                            89-300 Wyrzysk
                                            </p>
                                        </Content>
                                        </div>
                                    </GridItem>

                                    <GridItem span={12}>
                                        <div
                                        style={{
                                            display: "flex",
                                            gap: "1rem",
                                            alignItems: "flex-start"
                                        }}
                                        >
                                        <EnvelopeIcon />

                                        <Content>
                                            <strong>E-mail</strong>

                                            <p>
                                            <a href="mailto:sekretariat@domain.com">
                                                sekretariat@zspwyrzysk.pl
                                            </a>
                                            </p>
                                        </Content>
                                        </div>
                                    </GridItem>

                                    <GridItem span={12}>
                                        <div
                                        style={{
                                            display: "flex",
                                            gap: "1rem",
                                            alignItems: "flex-start"
                                        }}
                                        >
                                        <PhoneAltIcon />

                                        <Content>
                                            <strong>Telefon</strong>

                                            <p>
                                            <a href="tel:+48672867709">
                                                (067) 286 77 09
                                            </a>
                                            </p>
                                        </Content>
                                        </div>
                                    </GridItem>

                                    <GridItem span={12}>
                                        <div
                                        style={{
                                            display: "flex",
                                            gap: "1rem",
                                            alignItems: "flex-start"
                                        }}
                                        >
                                        <PhoneAltIcon />

                                        <Content>
                                            <strong>Fax</strong>

                                            <p>
                                                (067) 286 77 09
                                            </p>
                                        </Content>
                                        </div>
                                    </GridItem>
                                    </Grid>
                                </StackItem>
                                </Stack>
                            </CardBody>
                        </Card>
                    </GridItem>

                    <GridItem span={12} md={6}>
                    <Card isFullHeight isGlass>
                        <CardBody>
                            <Stack hasGutter>
                                {/* <StackItem>
                                    <Content>
                                    <h2>Dane placówki</h2>
                                    </Content>
                                </StackItem> */}
                                <StackItem>
                                    <Content>
                                    <strong>ePUAP:</strong>
                                    <p>
                                        /CKZiUWyrzysk/SkrytkaESP
                                    </p>
                                    </Content>
                                </StackItem>
                                <StackItem>
                                    <Content>
                                    <strong>eDoręczenia:</strong>
                                    <p>
                                        AE:PL-70684-58055-CUCTV-19
                                    </p>
                                    </Content>
                                </StackItem>
                                <StackItem>
                                    <Content>
                                    <strong>NIP</strong>
                                    <p>764-26-64-857</p>
                                    </Content>
                                </StackItem>

                                <StackItem>
                                    <Content>
                                    <strong>REGON</strong>
                                    <p>302491464</p>
                                    </Content>
                                </StackItem>
                            </Stack>
                        </CardBody>
                    </Card>
                    </GridItem>
                </Grid>
                </GridItem>
            </Grid>
            </StackItem>
        </Stack>
        </PageSection>
    </>
  );
};


export default ContactPage;